document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!form.matches('form[action*="/cart/add"]')) return;
  var button = form.querySelector('button[type="submit"]');
  if (!button) return;
  button.classList.add('is-loading');
  button.setAttribute('aria-busy', 'true');
});

document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
  var main = gallery.querySelector('[data-gallery-main]');
  var zoom = gallery.querySelector('[data-gallery-zoom]');
  var currentLabel = gallery.querySelector('[data-gallery-current]');
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
  var stage = gallery.querySelector('[data-gallery-stage]');
  var dialog = gallery.querySelector('[data-gallery-dialog]');
  var current = 0;
  var touchStartX = null;

  function show(index) {
    if (!thumbs.length) return;
    current = (index + thumbs.length) % thumbs.length;
    var selected = thumbs[current];
    main.src = selected.getAttribute('data-full');
    main.alt = selected.getAttribute('data-alt');
    if (zoom) {
      zoom.src = main.src;
      zoom.alt = main.alt;
    }
    thumbs.forEach(function (thumb, thumbIndex) {
      var active = thumbIndex === current;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      thumb.setAttribute('tabindex', active ? '0' : '-1');
    });
    if (currentLabel) currentLabel.textContent = String(current + 1);
    selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () { show(index); });
  });

  gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { show(current - 1); });
  gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { show(current + 1); });

  gallery.querySelector('[data-gallery-open]').addEventListener('click', function () {
    zoom.src = main.src;
    zoom.alt = main.alt;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  });

  gallery.querySelector('[data-gallery-close]').addEventListener('click', function () {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog && typeof dialog.close === 'function') dialog.close();
  });

  stage.addEventListener('touchstart', function (event) {
    touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });

  stage.addEventListener('touchend', function (event) {
    if (touchStartX === null) return;
    var distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 45) show(distance > 0 ? current - 1 : current + 1);
    touchStartX = null;
  }, { passive: true });
});

function sadelioPackTotal(quantityInput, quantity) {
  var unitPrice = parseInt(quantityInput.getAttribute('data-unit-price'), 10) || 0;
  var raw = quantityInput.getAttribute('data-pack-totals');
  if (raw) {
    try {
      var map = JSON.parse(raw);
      if (map[String(quantity)]) return parseInt(map[String(quantity)], 10);
    } catch (e) { /* fall through */ }
  }
  return unitPrice * quantity;
}

document.querySelectorAll('[data-product-quantity]').forEach(function (quantityInput) {
  var form = quantityInput.closest('form');
  var priceTarget = form && form.querySelector('[data-button-price]');
  if (!priceTarget) return;

  function updateQuantityPrice() {
    var quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
    var currency = quantityInput.getAttribute('data-currency') || 'EUR';
    quantityInput.value = quantity;
    priceTarget.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(sadelioPackTotal(quantityInput, quantity) / 100);
  }

  quantityInput.addEventListener('input', updateQuantityPrice);
  quantityInput.addEventListener('change', updateQuantityPrice);
});

document.querySelectorAll('[data-bundle-selector]').forEach(function (selector) {
  var form = selector.closest('form');
  var quantityInput = form && form.querySelector('[data-product-quantity]');
  var choices = Array.prototype.slice.call(selector.querySelectorAll('[data-bundle-choice]'));
  var mobileQuantity = document.querySelector('[data-mobile-quantity]');
  var mobilePrice = document.querySelector('[data-mobile-price]');
  if (!quantityInput || !choices.length) return;

  function selectBundle(choice) {
    var quantity = Math.max(1, parseInt(choice.value, 10) || 1);
    var currency = quantityInput.getAttribute('data-currency') || 'EUR';
    choices.forEach(function (item) {
      var option = item.closest('.bundle-option');
      if (option) option.classList.toggle('is-selected', item === choice);
    });
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    if (mobileQuantity) mobileQuantity.value = quantity;
    if (mobilePrice) mobilePrice.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(sadelioPackTotal(quantityInput, quantity) / 100);
  }

  choices.forEach(function (choice) {
    choice.addEventListener('change', function () { selectBundle(choice); });
  });
  selectBundle(choices.filter(function (choice) { return choice.checked; })[0] || choices[0]);
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.cart-drawer[open]').forEach(function (drawer) {
    if (!drawer.contains(event.target)) drawer.removeAttribute('open');
  });
});
